import http from '@/plugins/http';

export default (id) => new Promise((res, rej) => {
  http.get(`/v3/jobs/${id}`)
    .then((response) => {
      res(response.data);
    })
    .catch((error) => {
      rej(error);
    });
});
